import aboutIcon from './nav-assets/about.png'
import aiIcon from './nav-assets/ai.png'
import blogIcon from './nav-assets/blog.png'
import businessIntelligenceIcon from './nav-assets/business-intelligence.png'
import calculationsIcon from './nav-assets/calculations.png'
import careerIcon from './nav-assets/career.png'
import caseStudiesIcon from './nav-assets/case-studies.png'
import changelogIcon from './nav-assets/changelog.png'
import communityIcon from './nav-assets/community.png'
import compareIcon from './nav-assets/compare.png'
import contextModelingIcon from './nav-assets/context-modeling.png'
import customerSupportIcon from './nav-assets/customer-support.png'
import customersIcon from './nav-assets/customers.png'
import dataInputIcon from './nav-assets/data-input.png'
import dataModelingIcon from './nav-assets/data-modeling.png'
import developersIcon from './nav-assets/developers.png'
import documentsIcon from './nav-assets/documents.png'
import embeddedAnalyticsIcon from './nav-assets/embedded-analytics.png'
import exploTransitionIcon from './nav-assets/explo-transition.png'
import financialServicesIcon from './nav-assets/financial-services.png'
import integrationsIcon from './nav-assets/integrations.png'
import mediaAdvertisingIcon from './nav-assets/media-advertising.png'
import omnivisionIcon from './nav-assets/omnivision.png'
import partnersIcon from './nav-assets/partners.png'
import retailIcon from './nav-assets/retail.png'
import saasIcon from './nav-assets/saas.png'
import securityIcon from './nav-assets/security.png'
import spreadsheetsIcon from './nav-assets/spreadsheets.png'
import subscribeIcon from './nav-assets/subscribe.png'
import userGuidesIcon from './nav-assets/user-guides.png'

export {
  aboutIcon,
  aiIcon,
  blogIcon,
  businessIntelligenceIcon,
  calculationsIcon,
  careerIcon,
  caseStudiesIcon,
  changelogIcon,
  communityIcon,
  compareIcon,
  customerSupportIcon,
  customersIcon,
  dataInputIcon,
  dataModelingIcon,
  developersIcon,
  documentsIcon,
  embeddedAnalyticsIcon,
  exploTransitionIcon,
  financialServicesIcon,
  integrationsIcon,
  mediaAdvertisingIcon,
  omnivisionIcon,
  partnersIcon,
  retailIcon,
  saasIcon,
  securityIcon,
  spreadsheetsIcon,
  subscribeIcon,
  userGuidesIcon,
}

export const navRasterIconUrls = [
  aboutIcon,
  aiIcon,
  blogIcon,
  businessIntelligenceIcon,
  calculationsIcon,
  careerIcon,
  caseStudiesIcon,
  changelogIcon,
  communityIcon,
  compareIcon,
  contextModelingIcon,
  customerSupportIcon,
  customersIcon,
  dataInputIcon,
  dataModelingIcon,
  developersIcon,
  documentsIcon,
  embeddedAnalyticsIcon,
  exploTransitionIcon,
  financialServicesIcon,
  integrationsIcon,
  mediaAdvertisingIcon,
  omnivisionIcon,
  partnersIcon,
  retailIcon,
  saasIcon,
  securityIcon,
  spreadsheetsIcon,
  subscribeIcon,
  userGuidesIcon,
]
